(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    // Each newly inserted collection card initializes itself, including AJAX filter/load-more results.
if (!customElements.get('dm-card-gallery')) {
  customElements.define('dm-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.link = this.querySelector('.dm-card-gallery__link');
      this.templates = [...this.querySelectorAll('template[data-dm-photo]')];
      this.buttons = [...this.querySelectorAll('.dm-card-gallery__indicator')];
      if (!this.link || !this.buttons.length) return;
      this.images = [this.link.querySelector('img')];
      this.ready = [];
      this.index = this.desired = 0;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('.dm-card-gallery__indicators').hidden = false;
      this.buttons.forEach((button, i) => button.addEventListener('click', () => this.show(i), {signal}));
      this.link.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'mouse' && matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches) {
          const rect = this.link.getBoundingClientRect();
          this.show(Math.floor((event.clientX - rect.left) / rect.width * this.buttons.length));
        }
        if (this.gesture && event.pointerId === this.gesture.id) {
          this.gesture.dx = event.clientX - this.gesture.x;
          this.gesture.dy = event.clientY - this.gesture.y;
        }
      }, {signal});
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) this.show(0);
      }, {signal});
      this.link.addEventListener('pointerdown', (event) => {
        this.suppressUntil = 0;
        if (!event.isPrimary) return;
        if (event.pointerType === 'mouse' && matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches) return;
        this.gesture = {id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, dy: 0};
        this.link.setPointerCapture(event.pointerId);
        this.prepare(Math.min(this.index + 1, this.buttons.length - 1));
      }, {signal});
      // Decide intent early; only horizontal swipes cancel native page scrolling.
      this.link.addEventListener('touchmove', (event) => {
        if (!this.gesture || event.touches.length !== 1) return;
        const touch = event.touches[0];
        const dx = Math.abs(touch.clientX - this.gesture.x);
        const dy = Math.abs(touch.clientY - this.gesture.y);
        if (!this.gesture.axis && Math.max(dx, dy) >= 6) {
          if (dx > dy * 1.2) this.gesture.axis = 'x';
          else if (dy > dx * 1.2) this.gesture.axis = 'y';
        }
        if (this.gesture.axis === 'x' && event.cancelable) event.preventDefault();
      }, {passive: false, signal});
      this.link.addEventListener('pointerup', (event) => {
        const gesture = this.gesture;
        this.gesture = null;
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (gesture.axis !== 'y' && Math.abs(dx) > 8 && (gesture.axis === 'x' || Math.abs(dx) > Math.abs(dy))) {
          this.suppressUntil = Date.now() + 600;
          if (Math.abs(dx) >= 18) this.show(this.index + (dx < 0 ? 1 : -1));
        }
      }, {signal});
      this.link.addEventListener('pointercancel', () => {
        this.gesture = null;
        this.suppressUntil = Date.now() + 600;
      }, {signal});
      this.link.addEventListener('click', (event) => {
        if (Date.now() < (this.suppressUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, {capture: true, signal});
      this.link.addEventListener('dragstart', (event) => event.preventDefault(), {signal});
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.show(index);
      }, {signal});
    }
    prepare(index) {
      if (index === 0) return Promise.resolve(true);
      if (this.ready[index]) return this.ready[index];
      const template = this.templates[index - 1];
      if (!template) return Promise.resolve(false);
      const image = template.content.querySelector('img').cloneNode(true);
      image.setAttribute('aria-hidden', 'true');
      this.images[index] = image;
      this.ready[index] = new Promise((resolve) => {
        image.addEventListener('load', () => resolve(true), {once: true});
        image.addEventListener('error', () => resolve(false), {once: true});
      });
      this.link.append(image);
      if (image.complete) return (this.ready[index] = Promise.resolve(image.naturalWidth > 0));
      return this.ready[index];
    }
    async show(index) {
      index = Math.max(0, Math.min(this.buttons.length - 1, index));
      this.desired = index;
      if (index === this.index) return;
      if (!await this.prepare(index) || this.desired !== index || !this.isConnected) return;
      this.index = index;
      this.images.forEach((image, i) => {
        if (!image) return;
        image.classList.toggle('is-active', i === index);
        image.setAttribute('aria-hidden', String(i !== index));
      });
      this.buttons.forEach((button, i) => {
        button.classList.toggle('is-active', i === index);
        button.setAttribute('aria-pressed', String(i === index));
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.gesture = null;
      this.desired = -1;
      this.images?.forEach((image, i) => {
        if (i) image.remove();
        else { image.classList.add("is-active"); image.removeAttribute("aria-hidden"); }
      });
      this.buttons?.forEach((button, i) => {
        button.classList.toggle("is-active", i === 0);
        button.setAttribute("aria-pressed", String(i === 0));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
